import { TextField, TextFieldProps } from "@mui/material";
import { FieldProps } from "@rjsf/core";
import { useEffect, useState } from "react";

export const Decimal = ({formData, uiSchema, onChange, label}: DecimalProps) => {
    const [displayValue, setDisplayValue] = useState<string>('')
    const [value, setValue] = useState<number>(0)
    const textFieldOptions = uiSchema['ui:options']
    const { max, min, variant } = {
        max: Infinity,
        min: -Infinity,
        variant: 'standard' as "standard" | "filled" | "outlined" | undefined,
        ...textFieldOptions
    }

    useEffect(() => {
        setValue((v) => formData ?? v)
        if (!displayValue && formData) {            
            setDisplayValue(() => formData)
        }
    }, [formData])

    useEffect(() => {
        onChange(value)
    }, [value])

    const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value
        const num = parseFloat(newValue)
        setDisplayValue(() => newValue)
        if (!newValue || num < min || num > max) {
            setValue(() => 0)
            return
        }
        setValue((v) => isNaN(num) ? v : num)
    }

    return (<TextField
        {...textFieldOptions}
        type="number"
        variant={variant}
        label={label ?? ''}
        value={displayValue}
        onChange={handleTextFieldChange} />)
}

type DecimalProps = FieldProps & { uiSchema: { 'ui:options': TextFieldProps}}